import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import strings from '../../utils/strings';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './styles.scss';

import submitTestUserInfo from '../../api/submitTestUserInfo';

import {goToNextStep} from '../../actions/index';
import {setTestCandidateGrade} from '../../actions/index';

import {updateObject} from '../../utils/reducerUtils';

//import {TEST_USER_INFO_LABELS} from '../../constants';

import BooleanRadio from '../../components/BooleanRadio';
import {LANGUAGE as LANGUAGE_VERSION} from '../../constants';

moment.locale('nb');

const TEST_USER_INFO_LABELS = {
	gender: strings.gender,
	juniorHigh: strings.juniorHigh,
	highSchool: strings.highSchool,
	bachelor: strings.bachelor,
	master: strings.master,
	phd: strings.phd,
	other: strings.other,
	youthProgram: strings.youthProgram,
	accompanyingMeasures: strings.accompanyingMeasures,
	workPreparatoryTraining: strings.workPreparatoryTraining,
	norwegian: strings.norwegian,
	sapmi: strings.sapmi,
	russian: strings.russian,
	english: strings.english,
	arabic: strings.arabic,
	polish: strings.polish,
	kurdish: strings.kurdish,
	spanish: strings.spanish,
	tamil: strings.tamil,
	thai: strings.thai,
	turkish: strings.turkish,
	yes: strings.yes,
	no: strings.no,
	doesNotKnow:  strings.doesNotKnow,
	youthGrade2: '2.Klasse',
	youthGrade3: '3.Klasse',
	youthGrade4: '4.Klasse',
	youthGrade5: '5.Klasse',
	youthGrade6: '6.Klasse',
};


const youthGrades = [2,3,4,5,6,]; // eslint-disable-line

const FIRST_NAME = 'firstName';
const LAST_NAME = 'lastName';
const GENDER = 'gender';
const EMAIL = 'email';
const PHONE = 'phone';
const AGE = 'age';
const EDUCATION = 'education';
const YOUTH_GRADE = 'youthGrade';

const HOME_LANGUAGE = 'homeLanguage';
const GREW_UP_IN_BILINGUAL_HOME = 'grewUpInBilingualHome';

const now = moment();

const availableLanguages = {
	no: [
		{key: 'no', name: 'Norsk Bokmål'},
		{key: 'nn', name: 'Norsk Nynorsk'},
	],
	se: [{key: 'se', name: 'Svenska'}],
	de: [{key: 'de', name: 'Deutsch'}],
};

class Introduksjon extends React.Component {
	constructor(props) {
		super(props);
		strings.setLanguage(strings.getLanguage());

		this.state = {
			showLengthyIntro: props.includeLongAnamnese,
			languageCapability:null,
			submitEnabled: true,
			
			hasSelectedLanguage:
				availableLanguages[LANGUAGE_VERSION].length === 1, //Autoselects language if only one is available
			isFormValid: false,
			birthDate: moment().subtract(10, 'year').toDate(),
			candidateGrade: null,
			testUser: {
				firstName: '',
				lastName: '',
				gender: '',
				email: '',
				phone: '',
				age: {
					years: 0,
					months: 0,
				},
				education: {
					youthGrade: 0,
				},
				homeLanguage: {
					grewUpInBilingualHome: '',
					
				},
			},
		};
		this.onSelectLanguage = this.onSelectLanguage.bind(this);
	}

	updateTestUser(categoryKey, key, value) {
		const {testUser} = this.state;

		if (categoryKey) {
			const category = updateObject(testUser[categoryKey], {
				[key]: value,
			});

			this.setState({
				testUser: updateObject(testUser, {
					[categoryKey]: category,
				}),
			});
		} else {
			this.setState({
				testUser: updateObject(testUser, {
					[key]: value,
				}),
			});
		}
	}

	onSelectLanguage(lang) {
		strings.setLanguage(lang);
		this.setState({
			hasSelectedLanguage: true,
		});
	}

	render() {
		const {onGoToNextStep, onSetTestCandidateGrade} = this.props;
		const genders = [
			{
				label: strings.female,
				value: 'f',
			},
			{
				label: strings.male,
				value: 'm',
			},
		];
		const {
			isFormValid,
			birthDate,
			testUser,
			hasSelectedLanguage,
		} = this.state;

		const {
			email,
			phone,
			education,
			homeLanguage,
			gender,
			firstName,
			lastName,
		} = testUser;

		
		const yearsToSubtract = 5;
		let formRef;

		return !hasSelectedLanguage ? (
			<div className="lit-test-intro">
				<h1>{strings.chooseLanguage}</h1>
				{availableLanguages[LANGUAGE_VERSION].map((lang) => (
					<button
						key={lang.key}
						className="lit-test-intro-language-button"
						onClick={() => this.onSelectLanguage(lang.key)}
					>
						{lang.name}
					</button>
				))}
			</div>
		) : (
			<div className="lit-test-intro">
				<h1 className="lit-page-title">{strings.welcomeToTest}</h1>
				<div className="lit-intro lit-intro-card">
					<p>{strings.introInstructions}</p>
					<form
						className="pre-test-form lit-form-grid"
						onChange={() => {
							const formValidity = formRef.checkValidity();

							if (isFormValid !== formValidity) {
								this.setState({
									isFormValid: formValidity,
								});
							}
						}}
						onSubmit={(event) => {
							event.preventDefault();
							if (!this.state.submitEnabled) {
								return;
							}
							this.setState({
								submitEnabled: false,
							});
							submitTestUserInfo(testUser)
								.then(onGoToNextStep)
								.catch((err) => {
									console.log(err);
									this.setState({
										submitEnabled: true,
									});
								});
						}}
						ref={(ref) => {
							formRef = ref;
						}}
					>
						<br/>
						<div className="lit-input inline">
							<label
								className="lit-input__label wider"
								htmlFor="firstName"
							>
								{strings.firstName}
							</label>
							<input
								className="lit-input__field"
								id="test-candidate-modal-firstName"
								name="firstName"
								onChange={(event) => {
									const value = event.target.value;
									this.updateTestUser(
										null,
										FIRST_NAME,
										value
									);
								}}
								placeholder="Max"
								type="text"
								value={firstName}
								required
							/>
						</div>
						<div className="lit-input inline">
							<label
								className="lit-input__label wider"
								htmlFor="lastName"
							>
								{strings.lastName}
							</label>
							<input
								className="lit-input__field"
								id="test-candidate-modal-lastName"
								name="lastName"
								onChange={(event) => {
									const value = event.target.value;
									this.updateTestUser(null, LAST_NAME, value);
								}}
								placeholder="Mustermann"
								type="text"
								value={lastName}
								required
							/>
						</div>
						<div className="lit-input inline">
									<label className="lit-input__label wider">
										{strings.gender}
									</label>
									<div className="lit-input__field lit-radios">
										{genders.map((genderOption) => {
											const {label: genderLabel, value} =
												genderOption;

											return (
												<span
													className="lit-radio"
													key={value}
												>
													<input
														checked={
															value === gender
														}
														className="lit-radio__field"
														id={`gender${value}`}
														name="gender"
														onChange={() => {
															this.updateTestUser(
																null,
																GENDER,
																value
															);
														}}
														required
														type="radio"
													/>
													<label
														className="lit-radio__label"
														htmlFor={`gender${value}`}
													>
														{genderLabel}
													</label>
												</span>
											);
										})}
									</div>
								</div>
						
						<div className="lit-input inline">
							<label
								className="lit-input__label wider"
								htmlFor=""
							>
								{strings.birthDate}
							</label>
							<DatePicker
								className="lit-input__field"
								dropdownMode="select"
								inline
								maxDate={moment()
									.subtract(yearsToSubtract, 'years')
									.toDate()}
								name="age"
								onChange={(value) => {
									const numberOfMonths = 12;
									this.setState(
										{
											birthDate: value,
										},
										() => {
											const age = {
												years: now.diff(value, 'years'),
												months:
													now.diff(value, 'months') %
													numberOfMonths,
											};

											this.updateTestUser(null, AGE, age);
										}
									);
								}}
								placeholderText={strings.clickToSelectDate}
								required
								selected={birthDate}
								adjustDateOnChange
								showYearDropdown
							/>
						</div>

						<h2>{strings.education}</h2>
						<div className="lit-input">
							<label className="lit-input__label wider">
								{}
							</label>
							<div className="lit-input__field lit-radios-center">
								<div className="lit-chip-grid">
								{youthGrades.map((grade) => {
									return (
										<span className="lit-radio" key={grade}>
											<input
												checked={
													grade ===
													education[YOUTH_GRADE]
												}
												className="lit-radio__field"
												id={`youthGrade${grade}`}
												name="grade"
												onChange={() => {
													this.setState({
														candidateGrade: grade,
													});
													onSetTestCandidateGrade(
														grade
													);
													this.updateTestUser(
														EDUCATION,
														YOUTH_GRADE,
														grade
													);
												}}
												required
												type="radio"
											/>
											<label
												className="lit-radio__label"
												htmlFor={`youthGrade${grade}`}
											>
												{
													TEST_USER_INFO_LABELS[
														'youthGrade' + grade
													]
												}
											</label>
										</span>
									);
								})}
								</div>
							</div>
						</div>
							<div>
								<h2>{strings.homeLanguage}</h2>
								<div className="lit-input">
									<label className="lit-input__label wider">
										{strings.questionBilingualHome}
									</label>
									<BooleanRadio
										name={GREW_UP_IN_BILINGUAL_HOME}
										onChange={(value) => {
											const newVal = value ==1 ? true: value;
											// eslint-disable-next-line no-nested-ternary
											const languageCapability = value ===false ? 'one': value ===1 ? 'multiple':'two';
											this.updateTestUser(
												HOME_LANGUAGE,
												GREW_UP_IN_BILINGUAL_HOME,
												newVal
											);
											this.setState({
												languageCapability
											});
										}}
										value={
											`${this.state.languageCapability}`
										}
									/>
								</div>
							</div>
						

						{/* Make changes here */}
						<br />
						<div>
  <label>
    <input
      id="agreedToPrivacyPolicy"
      name="agreedToPrivacyPolicy"
      required
      type="checkbox"
    />{" "}
    {strings.privacyPolicyLabel}
  </label>

  <br />

  {strings.formatString(
    strings.privacyPolicyText,
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.dysmate.de/datenschutzerklarung/"
      style={{ color: "cyan", textDecoration: "underline" }}
    >
      {strings.privacyPolicy}
    </a>
  )}
</div>

						<button
							className="lit-btn lit-btn--huge bg-primary"
							type="submit"
						>
							{strings.start}
						</button>
					</form>
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(Introduksjon);
